import IconQuote from '@mnd-frontend/icons/components/Quote';
import {
  BREAKPOINTS,
  SIZING_4,
  SIZING_7,
  SPACING_2,
  SPACING_3,
  WEB_PURPLE_REG,
  WEB_RED_LT,
  WEB_WHITE_REG,
} from '@mnd-frontend/ui/shared/tokens';
import Image from 'next/image';
import { memo } from 'react';
import styled from 'styled-components';
import Badge from '../Badge';
import CardBase from '../CardBase';

// #region styled components
const Card = styled(CardBase)<{ $colorVariant: ColorVariant }>`
  background: ${({ $colorVariant }) => {
    switch ($colorVariant) {
      case 'white':
        return '#fff';
      case 'purple':
        return WEB_PURPLE_REG;
      case 'pink':
        return WEB_RED_LT;
    }
  }};
  color: ${({ $colorVariant }) => {
    switch ($colorVariant) {
      case 'white':
      case 'pink':
        return WEB_PURPLE_REG;
      case 'purple':
        return WEB_WHITE_REG;
    }
  }};
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: ${SPACING_3};
  padding: ${SPACING_2};
  flex-shrink: 0;

  @media (min-width: ${BREAKPOINTS.XS}px) {
    padding: ${SPACING_3};
  }
`;

const Quote = styled.p`
  //@todo: web/quote/desktop
  font-size: 1.5rem;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.045rem;
  margin: 0;
`;

const ContentMain = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING_3};
`;

const Contact = styled.div<{ $hasImage?: boolean }>`
  display: grid;
  grid-template-columns: ${({ $hasImage }) =>
    $hasImage ? `${SIZING_7} 1fr ${SIZING_4}` : `1fr ${SIZING_4}`};
  gap: ${SPACING_2};
  align-items: center;
`;

const ImageWrapper = styled.div`
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 50%;
  overflow: hidden;

  img {
    object-fit: cover;
  }
`;

const Name = styled.span`
  //@todo: web/body/highlight
  font-size: 1rem;
  font-weight: 600;
  line-height: 150%;
  margin: 0;
`;

const JobTitle = styled.span`
  //@todo: web/body/reg
  font-size: 1rem;
  font-weight: 400;
  line-height: 150%;
  display: block;
  margin: 0;
`;
// #endregion

type CardQuotationProps = {
  quote: string | null;
  organisation?: string | null;
  name: string | null;
  jobTitle?: string | null;
  profileImage?: string | null;
  colorVariant?: ColorVariant;
};

type ColorVariant = 'white' | 'purple' | 'pink';

const CardQuotation = ({
  quote,
  organisation,
  name,
  jobTitle,
  profileImage,
  colorVariant = 'white',
}: CardQuotationProps) => (
  <Card $colorVariant={colorVariant}>
    <ContentMain>
      {organisation && <Badge text={organisation} />}
      <Quote>{quote}</Quote>
    </ContentMain>
    <Contact $hasImage={!!profileImage}>
      {profileImage && (
        <ImageWrapper>
          <Image width={56} height={56} alt="" src={profileImage} />
        </ImageWrapper>
      )}
      <div>
        <Name>{name}</Name>
        {jobTitle && <JobTitle>{jobTitle}</JobTitle>}
      </div>
      <IconQuote $size="sm" aria-hidden />
    </Contact>
  </Card>
);

export default memo(CardQuotation);
